/**
 * Transform string from kebab case to camel case
 */
export function stringKebabToCamelCase(stringToTransform: string): string {
  return stringToTransform.replace(/-(.)/g, (match, letter) => letter.toUpperCase());
}
